import React from 'react'
import OpcionesCarousel from './OpcionesView/OpcionesCarousel'
import OpcionesBoton from './OpcionesView/OpcionesBoton'
import OpcionesTexto from './OpcionesView/OpcionesTexto'
import OpcionesTitulo from './OpcionesView/OpcionesTitulo'
import OpcionesEspaciadorVertical from './OpcionesView/OpcionesEspaciadorVertical'
import OpcionesBotonImagen from './OpcionesView/OpcionesBotonImagen'
import OpcionesTamano from './OpcionesView/OpcionesTamano'
import OpcionesIconoTexto from './OpcionesView/OpcionesIconoTexto'
import OpcionesMenuNavegacion from './OpcionesView/OpcionesMenuNavegacion'
import OpcionesMapas from './OpcionesView/OpcionesMapas'
import OpcionesImagen from './OpcionesView/OpcionesImagen'
import OpcionesBannerSecundario from './OpcionesView/OpcionesBannerSecundario'
import OpcionesFooter from './OpcionesView/OpcionesFooter'
import OpcionesGaleria from './OpcionesView/OpcionesGaleria'
import OpcionesTarjeta1 from './OpcionesView/OpcionesTarjeta1'

const OpcionesPagina = (props) => {
    const { type } = props;

    if (type === "carousel") return <OpcionesTamano {...props}><OpcionesCarousel {...props} /></OpcionesTamano>
    if (type === "button") return <OpcionesTamano {...props}> <OpcionesBoton {...props} /> </OpcionesTamano >
    if (type === 'texto') return <OpcionesTamano {...props}> <OpcionesTexto {...props} /> </OpcionesTamano >
    if (type === 'bannerPaginaIndividual') return <OpcionesTamano {...props}> <OpcionesTexto {...props} /> </OpcionesTamano >
    if (type === 'titulo') return <OpcionesTamano {...props}> <OpcionesTitulo {...props} /> </OpcionesTamano >
    if (type === 'espaciadorVertical') return <OpcionesTamano {...props}> <OpcionesEspaciadorVertical {...props} /> </OpcionesTamano >
    if (type === 'botonImagen') return <OpcionesTamano {...props}> <OpcionesBotonImagen {...props} /> </OpcionesTamano >
    if (type === 'iconoTexto') return <OpcionesTamano {...props}> <OpcionesIconoTexto {...props} /> </OpcionesTamano >
    if (type === 'divPrincipal' || type === 'agregarCampos') return <OpcionesTamano {...props} />
    if (type === 'menuNavegacion') return <OpcionesTamano {...props}> <OpcionesMenuNavegacion {...props} /> </OpcionesTamano >
    if (type === 'mapa') return <OpcionesTamano {...props}> <OpcionesMapas {...props} /> </OpcionesTamano >
    if (type === 'imagen') return <OpcionesTamano {...props}> <OpcionesImagen {...props} /> </OpcionesTamano >
    if (type === 'bannerSecundario') return <OpcionesTamano {...props}> <OpcionesBannerSecundario {...props} /> </OpcionesTamano >
    if (type === 'footer') return <OpcionesTamano {...props}> <OpcionesFooter {...props} /> </OpcionesTamano >
    if (type === 'verificarPago') return <OpcionesTamano {...props} />
    if (type === 'galeria') return <OpcionesTamano {...props}> <OpcionesGaleria {...props} /> </OpcionesTamano >
    if (type === 'login') return <OpcionesTamano {...props} />
    if (type === 'tarjeta1') return <OpcionesTamano {...props}> <OpcionesTarjeta1  {...props} /> </OpcionesTamano>
}

export default OpcionesPagina